import {BarChartGroup} from "./BarChartGroup/BarChartGroup";

export class BarChartGroupComponent {
  constructor(container) {
    if (!container) {
      throw new Error('Container element is required');
    }

    this.container = container;
    this.horizontalElements = this.container.querySelectorAll('[data-horizontal-chart-group]');
    this.verticalElements = this.container.querySelectorAll('[data-vertical-chart-group]');

    this.horizontalComponents = [];
    this.verticalComponents = [];

    if (this.horizontalElements.length > 0) {
      this.initHorizontal();
    }

    if (this.verticalElements.length > 0) {
      this.initVertical();
    }

  }

  initHorizontal() {
    this.horizontalElements.forEach((group) => {
      const chart = new BarChartGroup(group, {
        placeholderColor: "var(--chart-bg, #DADADA33)",
        fillerColor:
          "var(--chart-filler, linear-gradient(90deg, #172225 0%, #2B99B8 73.7%))",
        animationDuration: 0.6,
        animationDelay: 0.1,
        counterDuration: 1.5,
      });

      this.horizontalComponents.push(chart);
    });
  }

  initVertical() {
    this.verticalElements.forEach((group) => {
      const chart = new BarChartGroup(group, {
        placeholderColor: "var(--chart-bg, #DADADA33)",
        fillerColor: "#EE6C5C",
        animationDuration: 0.6,
        animationDelay: 0.1,
        counterDuration: 1.5,
        type: "vertical"
      });

      this.verticalComponents.push(chart);
    });
  }


  dispose() {
    if (this.horizontalComponents.length) {
      this.horizontalComponents.forEach(component => {
        component.dispose();
      })
    }

    if (this.verticalComponents.length) {
      this.verticalComponents.forEach(component => {
        component.dispose();
      })
    }

    this.horizontalComponents = null;
    this.verticalComponents = null;
    this.horizontalElements = null;
    this.verticalElements = null;
    this.container = null;
  }

}
